import { createContext } from '@/utils';
import type { ScheduleContextValue } from './types';

export const ScheduleContext = createContext<ScheduleContextValue | undefined>(
  undefined,
  'ScheduleContext'
);
